export default {
  setStudents(state, data) {
    state.students = data;
  },

  clearStudents(state) {
    state.students = [];
  },

  setStudent(state, data) {
    state.student = data;
  },

  clearStudent(state) {
    state.student = null;
  },
};
